import {
    allFetch
} from "../Domain";

/**
 * @description 車型查詢
 */
export const CarType = (() => {
    /**
     * @description 車籍查詢
     */
    const CarTypeSearch = async function (obj = {
        car_type: "",
        car_type_name: "",
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('CarType/CarTypeSearch', obj);
    }

    /**
     * @description 車型新建
     */
    const CarTypeCreate = async function (obj = {
        car_type: "",
        car_type_name: "",
        company_rule: ''
    }) {
        return await allFetch('CarType/CarTypeCreate', obj);
    }

    /**
     * @description 車型刪除
     */
    const CarTypeDelete = async function (obj = {
        ct_id: ''
    }) {
        return await allFetch('CarType/CarTypeDelete', obj);
    }

    /**
     * @description 車型細項
     */
    const CarTypeDetail = async function (obj = {
        ct_id: ''
    }) {
        return await allFetch('CarType/CarTypeDetail', obj);
    }

    /**
     * @description 車型細項
     */
    const CarTypeUpdate = async function (obj = {
        ct_id: '',
        car_type: "",
        car_type_name: "",
        company_rule: ''
    }) {
        return await allFetch('CarType/CarTypeUpdate', obj);
    }

    /**
     * @description 車型規格對照新建
     */
    const CarTypeFormatCreate = async function (obj = {
        ct_id: '',
        format_code: '',
        format_name: ''
    }) {
        return await allFetch('CarType/CarTypeFormatCreate', obj);
    }

    /**
     * @description 車型規格對照查詢
     */
    const CarTypeFormatSearch = async function (obj = {
        car_type: "",
        car_type_name: "",
        format_code: '',
        format_name: '',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('CarType/CarTypeFormatSearch', obj);
    }

    /**
     * @description 車型規格對照修改
     */
    const CarTypeFormatUpdate = async function (obj = {
        ctf_id: '',
        ct_id: '',
        format_code: '',
        format_name: ''
    }) {
        return await allFetch('CarType/CarTypeFormatUpdate', obj);
    }

    /**
     * @description 車型規格對照刪除
     */
    const CarTypeFormatDelete = async function (obj = {
        ctf_id: ''
    }) {
        return await allFetch('CarType/CarTypeFormatDelete', obj);
    }

    /**
     * @description 車型規格訂價查詢
     */
    const CarTypeFormatPriceSearch = async function (obj = {
        car_type: "",
        car_type_name: "",
        format_code: '',
        format_name: '',
        year: '',
        valid_date_start: '',
        valid_date_end: '',
        invalid_date_start: '',
        invalid_date_end: '',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('CarType/CarTypeFormatPriceSearch', obj);
    }

    /**
     * @description 車型規格訂價新建
     */
    const CarTypeFormatPriceCreate = async function (obj = {
        ctf_id: '',
        year: '',
        car_type_price: '',
        repayment_price: '',
        valid_date: '',
        invalid_date: ''
    }) {
        return await allFetch('CarType/CarTypeFormatPriceCreate', obj);
    }

    /**
     * @description 車型規格訂價細項
     */
    const CarTypeFormatPriceDetail = async function (obj = {
        ctfp_id: ''
    }) {
        return await allFetch('CarType/CarTypeFormatPriceDetail', obj);
    }

    /**
     * @description 車型規格訂價刪除
     */
    const CarTypeFormatPriceDelete = async function (obj = {
        ctfp_id: ''
    }) {
        return await allFetch('CarType/CarTypeFormatPriceDelete', obj);
    }

    /**
     * @description 車型規格訂價修改
     */
    const CarTypeFormatPriceUpdate = async function (obj = {
        ctfp_id: ''
    }) {
        return await allFetch('CarType/CarTypeFormatPriceUpdate', obj);
    }

    /**
     * @description 車型外裝加價查詢
     * @param {string} car_type 車型代碼
     * @param {string} car_type_name 車型名稱
     * @param {string} format_code 規格代碼
     * @param {string} format_name 規格名稱
     * @param {string} exterior_code 外裝顏色代碼
     * @param {string} exterior_color 外裝顏色名稱
     * @param {string} valid_date_start 可受訂起始日期起
     * @param {string} valid_date_end 可受訂起始日期迄
     * @param {string} invalid_date_start 不可受訂起始日期起
     * @param {string} invalid_date_end 不可受訂起始日期迄
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const CarTypeExteriorPriceSearch = async function (obj = {
        car_type: '',
        car_type_name: '',
        format_code: '',
        format_name: '',
        exterior_code: '',
        exterior_color: '',
        valid_date_start: '',
        valid_date_end: '',
        invalid_date_start: '',
        invalid_date_end: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarType/CarTypeExteriorPriceSearch', obj);
    }

    /**
     * @description 車型內裝加價查詢
     * @param {string} car_type 車型代碼
     * @param {string} car_type_name 車型名稱
     * @param {string} format_code 規格代碼
     * @param {string} format_name 規格名稱
     * @param {string} exterior_code 內裝顏色代碼
     * @param {string} exterior_color 內裝顏色名稱
     * @param {string} valid_date_start 可受訂起始日期起
     * @param {string} valid_date_end 可受訂起始日期迄
     * @param {string} invalid_date_start 不可受訂起始日期起
     * @param {string} invalid_date_end 不可受訂起始日期迄
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const CarTypeInteriorPriceSearch = async function (obj = {
        car_type: '',
        car_type_name: '',
        format_code: '',
        format_name: '',
        interior_code: '',
        interior_color: '',
        valid_date_start: '',
        valid_date_end: '',
        invalid_date_start: '',
        invalid_date_end: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarType/CarTypeInteriorPriceSearch', obj);
    }

    /**
     * @description 車型外裝對照查詢
     * @param {string} exterior_code 外裝代碼
     * @param {string} exterior_color 外裝名稱
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const CarExteriorSearch = async function (obj = {
        exterior_code: '',
        exterior_color: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarType/CarExteriorSearch', obj);
    }

    /**
     * @description 車型內裝對照查詢
     * @param {string} interior_code 內裝代碼
     * @param {string} interior_color 內裝名稱
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const CarInteriorSearch = async function (obj = {
        interior_code: '',
        interior_color: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('CarType/CarInteriorSearch', obj);
    }

    return {
        CarTypeSearch,
        CarTypeCreate,
        CarTypeDelete,
        CarTypeDetail,
        CarTypeUpdate,
        CarTypeFormatCreate,
        CarTypeFormatSearch,
        CarTypeFormatUpdate,
        CarTypeFormatDelete,
        CarTypeFormatPriceSearch,
        CarTypeFormatPriceCreate,
        CarTypeFormatPriceDetail,
        CarTypeFormatPriceDelete,
        CarTypeFormatPriceUpdate,
        CarTypeExteriorPriceSearch,
        CarTypeInteriorPriceSearch,
        CarExteriorSearch,
        CarInteriorSearch
    }
})();